module.exports = __webpack_public_path__ + "images/home_01.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/img/header_pics/home_01.jpg
// module id = 768
// module chunks = 0